// extracted by mini-css-extract-plugin
module.exports = {"gardening":"Gardening_gardening__154Wr","intro":"Gardening_intro__26hZc","cardbox":"Gardening_cardbox__1QmR9","card":"Gardening_card__3-1PI"};